module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet box green"
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('i', {
    staticClass: "fa fa-heartbeat",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Medicação eventual")])])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('form', {
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.addEventualMedicineItem($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-3 col-xs-3",
    class: {
      'has-error': _vm.errors.has('medicine-time')
    }
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "control-label",
    attrs: {
      "for": "medicine-time"
    }
  }, [_vm._v("Horário")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('##:##'),
      expression: "'##:##'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.medicine.time),
      expression: "medicine.time"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true,
          regex: /([01]\d|2[0-3]):([0-5]\d)/
        }
      }),
      expression: "{ rules: { required: true, regex: /([01]\\d|2[0-3]):([0-5]\\d)/} }"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "medicine-time",
      "name": "medicine-time",
      "placeholder": "Exemplo: 16:00"
    },
    domProps: {
      "value": (_vm.medicine.time)
    },
    on: {
      "change": function($event) {
        _vm.completionStatus(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.medicine, "time", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6 col-xs-6",
    class: {
      'has-error': _vm.errors.has('medicine-medicine')
    }
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "control-label",
    attrs: {
      "for": "medicine-medicine"
    }
  }, [_vm._v("Medicação")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicine.medicine),
      expression: "medicine.medicine"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "medicine-medicine",
      "name": "medicine-medicine",
      "placeholder": "Medicação"
    },
    domProps: {
      "value": (_vm.medicine.medicine)
    },
    on: {
      "change": function($event) {
        _vm.completionStatus(_vm.medicine)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.medicine, "medicine", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-3 col-xs-3",
    class: {
      'has-error': _vm.errors.has('medicine-dosage')
    }
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "control-label",
    attrs: {
      "for": "medicine-dosage"
    }
  }, [_vm._v("Dosagem")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicine.dosage),
      expression: "medicine.dosage"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "medicine-dosage",
      "name": "medicine-dosage",
      "placeholder": "Dosagem"
    },
    domProps: {
      "value": (_vm.medicine.dosage)
    },
    on: {
      "change": function($event) {
        _vm.completionStatus(_vm.medicine)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.medicine, "dosage", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-9 col-xs-12",
    class: {
      'has-error': _vm.errors.has('medicine-reason')
    }
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "control-label",
    attrs: {
      "for": "medicine-reason"
    }
  }, [_vm._v("Observações/Justificativas:")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicine.reason),
      expression: "medicine.reason"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "medicine-reason",
      "name": "medicine-reason",
      "rows": "3",
      "maxlength": "1000"
    },
    domProps: {
      "value": (_vm.medicine.reason)
    },
    on: {
      "change": function($event) {
        _vm.completionStatus(_vm.medicine)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.medicine, "reason", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-12"
  }, [_c('button', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "btn btn-block green btn-add",
    attrs: {
      "type": "submit",
      "disabled": _vm.errors.items.length > 0
    }
  }, [_vm._v("\n\t\t\t\t\t\tAdicionar\n\t\t\t\t\t")])])])]), _vm._v(" "), (_vm.eventualMedicines && _vm.eventualMedicines.length > 0) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.eventualMedicines && _vm.eventualMedicines.length > 0) ? _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-hover m-b-0"
  }, [_c('thead', [_c('tr', [_c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Horário")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Medicação")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Observações")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.eventualMedicines), function(medicine, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm._f("date")(medicine.time, 'HH:mm', true)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(medicine.medicine) + " - " + _vm._s(medicine.dosage))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(medicine.reason))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-info btn-xs",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.editEventualMedicineItem(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-xs",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deleteEventualMedicineItem(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  }))])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22cbbe7c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./sources/domains/agenda/health/eventual-medicine/main.vue
// module id = 1045
// module chunks = 1